import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'

import SelectInput from '../../../common/SelectInput'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import useDebouncedValue from '../../../../utils/common_function'
import { NavContext } from '../../../../context/global_context'
import {
  AppsContext,
  SET_APPS_DATA,
  SET_SELECTED_APPS_DATA,
  SHOW_APPS_FORM,
  UPDATE_CHANGE_APPS_DATA,
} from '../context/context'

const AppsForm = ({ getAppList = () => {} }) => {
  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(AppsContext)

  const saveApp = async (e) => {
    if (window.confirm(`Are you sure want to setup app`) === true) {
      navDispatch({
        type: 'loader',
        data: {
          caption: `Saving App.`,
          showLoader: true,
        },
        notification: {},
      })

      const form = e.target
      const formData = new FormData(form)

      let res = await postRequest(`/api/oauth/save/`, formData)
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'App Saved Successfully',
          },
        })
        getAppList()
        dispatch({ type: SHOW_APPS_FORM, data: {}, showFormPopup: false })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({ type: SHOW_APPS_FORM, data: {}, showFormPopup: false })
      }}
      show={state.showFormPopup}
    >
      <ModalHeader className={'text-white'}>
        {state?.selectedObject?.id
          ? `Update ${state?.selectedObject?.name}`
          : 'Create New App'}
      </ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveApp(e)
          }}
        >
          <input
            type="hidden"
            value={state?.selectedObject?.id ? false : true}
            name="is_create"
          />
          {state?.selectedObject?.id && (
            <input type="hidden" name="id" value={state?.selectedObject?.id} />
          )}

          <div className="flex">
            <div className="w-full">
              <InputText
                name="name"
                type="text"
                label="App Name"
                value={state?.selectedObject?.name}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_APPS_DATA,
                    data: {
                      ...state?.selectedObject,
                      name: value,
                    },
                    showFormPopup: true,
                  })
                }}
                readOnly={state?.selectedObject?.id ? true : false}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-full">
              <InputText
                name="make"
                type="text"
                label="Make Details"
                value={state?.selectedObject?.make}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_APPS_DATA,
                    data: {
                      ...state?.selectedObject,
                      make: value,
                    },
                    showFormPopup: true,
                  })
                }}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-full">
              <InputText
                name="allowed_domain"
                type="text"
                label="Allowed Domains (Comma Seperated http://example.com)"
                value={state?.selectedObject?.allowed_domain}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_APPS_DATA,
                    data: {
                      ...state?.selectedObject,
                      allowed_domain: value,
                    },
                    showFormPopup: true,
                  })
                }}
              />
            </div>
          </div>

          <div className="flex justify-end">
            <div className="w-1/4">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 px-2 w-full justify-end`}
                onClick={(e) => {}}
                value={'text'}
                text={'Save App'}
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default AppsForm
